import { render, staticRenderFns } from "./confirmDeletionServerModal.vue?vue&type=template&id=47fe9b07&"
import script from "./confirmDeletionServerModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionServerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports